<template>
  <a-modal
    centered
    title="更多操作"
    v-model="visible"
    width="800px"
    :maskClosable="false"
    :destroyOnClose="true"
    @cancel="visible = false"
    :footer="null"
  >
    <div class="opertion-btns">
      <a-button
        class="cancel-btn"
        @click="cancelOrder"
        v-if="orderId && option.canCancel"
        >取消桌台</a-button
      >
      <a-button
        type="primary"
        class="ml"
        v-if="orderId"
        :disabled="orderData.Status == 2"
        @click="changeTable"
        >换台</a-button
      >
      <!-- <a-button
        type="primary"
        class="ml"
        v-if="orderData.Status == 1 && orderData.IsOnlinePay"
        @click="getOrderQuery"
        >查询微信支付结果</a-button
      > -->
    </div>
    <ChangeTable ref="ChangeTable" @update="getChangeTable" />
  </a-modal>
</template>
<script>
import "./orderFood.less";
import ChangeTable from "./ChangeTable";
export default {
  components: { ChangeTable },
  data() {
    return {
      visible: false,
      orderId: "",
      option: {},
      emptyTable: [],
      orderData: {},
      showPayResult: true,
      payResult: {}
    };
  },

  created() {},
  methods: {
    show(orderId, orderData, option) {
      this.visible = true;
      this.orderId = orderId;
      this.orderData = orderData;
      this.option = option ? option : {};
    },
    cancelOrder() {
      this.$emit("cancelOrder");
    },
    changeTable() {
      const data = this.orderData.DishTables.filter(el => el.OrderStatus != 2);
      this.$refs.ChangeTable.show(this.orderId, data);
    },
    getChangeTable(tableId) {
      if (this.$route.query.tableId) {
        this.$router.push({
          name: "OrderFood",
          query: {
            orderId: this.orderId,
            tableId: tableId
          }
        });
      }

      this.visible = false;
      this.$emit("update");
    },
    reload() {
      this.visible = false;
      this.$emit("update");
    }
  }
};
</script>

<style lang="less" scoped></style>
